import { useState } from "react";
import Button from "../../components/common/button";
import useGetDepartmentsData from "../../hooks/use-get-department-data";
import CurrentStaff from "./current-staff";
import StaffModal from "./add-staff-modal";
import Spinner from "../../components/common/Spinner";
import { useGetUserPermission } from "../../context/AuthStaffUserContext";

const Staff: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const { data, isLoading } = useGetDepartmentsData();
  const departmentsData = data?.result?.data?.departmentsData;

  const { write: isEditPermission } = useGetUserPermission("staff");

  if (isLoading) {
    return <Spinner fullScreenOverlay className="z-[100]" />;
  }
  if (!departmentsData) {
    return <div>Error while fetching departmentsData</div>;
  }

  return (
    <div className="p-6 min-h-full">
      <div className="flex justify-between items-center">
        <h2 className="text-xl text-[#1E2F65] ">Staff</h2>
        <Button
          disabled={!isEditPermission}
          variant="primary"
          className="w-21"
          onClick={openModal}
        >
          Add New
        </Button>
      </div>
      <div className="mt-6 bg-white py-8 px-8">
        <h2 className="text-xl text-[#1E2F65] mb-4">Staff List</h2>
        <CurrentStaff departmentsData={departmentsData} />
      </div>

      {isModalOpen && (
        <StaffModal
          isOpen={isModalOpen}
          closeModal={closeModal}
          departmentsData={departmentsData}
        />
      )}
    </div>
  );
};

export default Staff;
